import { useState, useRef } from 'react'
import { RatingType, QuestionItem, QuestionDetail, AnnotationKey, StateType } from '@/types/annotation'
import { queryQuestionList, queryQuestionDetail, annotationData } from '@/services/apis/aiwriter'
import dayjs from 'dayjs'

const useAnnotationModel = () => {
  // 显示弹框
  const [showAnnotation, setShowAnnotation] = useState(false)
  // 未标注计数
  const [count, setCount] = useState(0)
  // 切换all 
  const [annotationKey, setAnnotationKey] = useState<AnnotationKey>(AnnotationKey.ALL)
  // 打分
  const [rating, setRating] = useState<RatingType>(RatingType.NULL)
  // 当前问题列表
  const [allList, setAllList] = useState<QuestionItem[]>([])
  // 当前问题详情
  const [detail, setDetail] = useState<QuestionDetail>()
  // 当前日期
  const [currentDate, setCurrentDate] = useState('')
  // 加载列表loading
  const [loadingList, setLoadingList] = useState(false)
  // 加载详情loading
  const [loadingDetail, setLoadingDetail] = useState(false)

  const annotationKeyRef = useRef<AnnotationKey>(annotationKey)
  const allListRef = useRef<QuestionItem[]>([])

  // 获取问题列表
  const getQuestionList = async (date: string) => {
    if (loadingList) return
    const newDate = dayjs(date).format('YYYYMMDD')
    let list = [] as QuestionItem[]
    setLoadingList(true)
    setAllList([])
    try {
      const data = await queryQuestionList({ date: newDate })
      list = data.annotations
    } catch (e) {
      console.log(e)
    }
    const noAnnoList = list.filter(item => item.state === StateType.UNANNOTATED)
    const tempList = annotationKeyRef.current === AnnotationKey.ALL ? list : noAnnoList
    setAllList(tempList)
    setLoadingList(false)
    allListRef.current = tempList
    setCount(noAnnoList.length)
    if (tempList.length > 0) {
      getQuestionDetail(tempList[0].id)
    } else {
      setDetail(undefined)
      setRating(RatingType.NULL)
    }
  }

  // 获取问题详情
  const getQuestionDetail = async (id: string) => {
    if (id === detail?.id) {
      return
    }

    setLoadingDetail(true)
    try {
      const data = await queryQuestionDetail({ id })
      setDetail(data)
      setRating(data?.rating || RatingType.NULL)
    } catch (e) {
      console.log(e)
    }
    setLoadingDetail(false)
  }

  // 打分
  const selectRating = async (rateData: { id: string, rating: RatingType, callback: (item: QuestionDetail) => void }) => {
    try {
      const { id, rating, callback } = rateData
      const res = await annotationData(id ,{ rating, state: StateType.ANNOTATED })
      const { data } = res
      callback(data)
      // 更新count
      let num = 0
      const list = allListRef.current
      const newList: QuestionItem[] = []
      // 打分之后根据返回值重新计算count，以及更新list
      list.forEach(item => {
        if (item.id === data.id) {
          newList.push({
            id: data.id,
            question: item.question,
            state: data.state
          })
          if (data.state === StateType.UNANNOTATED) {
            num++
          }
        } else {
          newList.push(item)
          if (item.state === StateType.UNANNOTATED) {
            num++
          }
        }
      })
      setCount(num)
      setAllList(newList)
      setDetail(data)
      setRating(data.rating || RatingType.NULL)
    } catch (e) {
      console.log(e)
    }
  }


  return {
    showAnnotation,
    setShowAnnotation,
    allList,
    getQuestionList,
    detail,
    annotationKey,
    setAnnotationKey: (key: AnnotationKey) => {
      setAnnotationKey(key)
      annotationKeyRef.current = key
    },
    rating,
    setRating,
    currentDate,
    setCurrentDate,
    getQuestionDetail,
    count,
    loadingList,
    loadingDetail,
    setCount,
    selectRating,
    setAllList,
  }
}

export default useAnnotationModel